import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.5.7_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.7_react-dom@19.2.1_react@19.2.1__react@19.2.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/blog/what-is-digital-marketing/digital-marketing.webp");
;
import(/* webpackMode: "eager", webpackExports: ["FadeIn"] */ "/vercel/path0/src/components/FadeIn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContents"] */ "/vercel/path0/src/components/TableOfContents.tsx");
